enum SourceTestament {
    Old = 'old',
    New = 'new',
    Both = 'both'
}

export default SourceTestament;
